import { useEffect } from "react";

export default function usePublicPageScroll() {
  useEffect(() => {
    document.documentElement.classList.add("public-page");
    document.body.classList.add("public-page");

    return () => {
      document.documentElement.classList.remove("public-page");
      document.body.classList.remove("public-page");
    };
  }, []);
}
